import {connect} from '@modifi/redux'

import ProgressBar from './ProgressBar'

const mapStateToProps = null

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ProgressBar)
